import React from 'react';
import { Label, Row, Spinner } from '@ydistri/ds';
import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

const CalculationStatusLabel = styled(Label)`
  color: ${() => COLORS.GREY_DARK};
`;

interface CalculationStatusComponentProps {
  label: string;
  showSpinner?: boolean;
  spinnerColor?: string;
}

const CalculationStatusComponent: React.FC<CalculationStatusComponentProps> = ({
  label,
  showSpinner = true,
  spinnerColor = 'blue',
}) => {
  return (
    <Row $alignItems="center" $gap="0.5rem">
      {showSpinner && <Spinner color={spinnerColor} />}
      <CalculationStatusLabel>{label}</CalculationStatusLabel>
    </Row>
  );
};

export default CalculationStatusComponent;
